import { useEffect } from "react";

/**
 * This hook is used to fire a passed function every [timeout] ms.
 */
export function useInterval(fn: () => void, timeout = 500, dependencies = []) {
	/** Effect */
	useEffect(() => {
		const interval = setInterval(fn, timeout);
		return () => {
			clearInterval(interval);
		};
	}, [fn, timeout].concat(dependencies));
}
